document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".custom-slider-luksonslider");
  if (!slider) return;

  const wrapper = slider.querySelector(".slides");
  let slides = slider.querySelectorAll(".slide");
  const dotsContainer = slider.querySelector(".dots");

  if (slides.length <= 1) return; // safety

  let index = 1;
  let autoSlide;

  // 👉 CLONE
  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slides.length - 1].cloneNode(true);

  wrapper.appendChild(firstClone);
  wrapper.insertBefore(lastClone, slides[0]);

  slides = slider.querySelectorAll(".slide");

  // 👉 INITIAL POSITION
  wrapper.style.transform = `translateX(-100%)`;

  // 👉 DOTS
  for (let i = 0; i < slides.length - 2; i++) {
    const dot = document.createElement("button");
    if (i === 0) dot.classList.add("active");

    dot.addEventListener("click", () => {
      index = i + 1;
      updateSlider();
    });

    dotsContainer.appendChild(dot);
  }

  const dots = dotsContainer.querySelectorAll("button");

  function updateDots() {
    let realIndex = index - 1;

    if (realIndex < 0) realIndex = dots.length - 1;
    if (realIndex >= dots.length) realIndex = 0;

    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[realIndex]) dots[realIndex].classList.add("active");
  }

  function updateSlider() {
    if (!slides[index]) return;

    wrapper.style.transition = "transform 0.5s ease";
    wrapper.style.transform = `translateX(-${index * 100}%)`;
    updateDots();
  }

  // 👉 LOOP FIX
  wrapper.addEventListener("transitionend", () => {
    if (!slides[index]) return;

    if (slides[index].isSameNode(firstClone)) {
      wrapper.style.transition = "none";
      index = 1;
      wrapper.style.transform = `translateX(-${index * 100}%)`;
    }

    if (slides[index].isSameNode(lastClone)) {
      wrapper.style.transition = "none";
      index = slides.length - 2;
      wrapper.style.transform = `translateX(-${index * 100}%)`;
    }
  });

  // 👉 AUTO SLIDE
  function startAuto() {
    clearInterval(autoSlide);
    autoSlide = setInterval(() => {
      if (index >= slides.length - 1) return;
      index++;
      updateSlider();
    }, 5000);
  }

  function stopAuto() {
    clearInterval(autoSlide);
  }

  startAuto();

  // 👉 DRAG
  let startX = 0;
  let isDragging = false;

  wrapper.addEventListener("mousedown", (e) => {
    isDragging = true;
    startX = e.pageX;
    wrapper.style.transition = "none";
    stopAuto();
  });

  wrapper.addEventListener("mousemove", (e) => {
    if (!isDragging) return;

    let diff = e.pageX - startX;
    wrapper.style.transform = `translateX(calc(${-index * 100}% + ${diff}px))`;
  });

  wrapper.addEventListener("mouseup", (e) => {
    if (!isDragging) return;

    let diff = e.pageX - startX;

    if (diff > 80) index--;
    else if (diff < -80) index++;

    updateSlider();
    isDragging = false;
    startAuto();
  });

  wrapper.addEventListener("mouseleave", () => {
    if (isDragging) {
      updateSlider();
      isDragging = false;
      startAuto();
    }
  });

  // 👉 TOUCH
  wrapper.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    stopAuto();
  });

  wrapper.addEventListener("touchend", (e) => {
    let diff = e.changedTouches[0].clientX - startX;

    if (diff > 80) index--;
    else if (diff < -80) index++;

    updateSlider();
    startAuto();
  });

});